<template>
  <div id="map-marker" />
</template>

<script>
import L from 'leaflet'
import 'leaflet-extra-markers'
import 'leaflet.marker.slideto'

import { getMapParent } from '@/utils/utils'

export default {
  name: 'MapMarker',
  props: {
    coordinates: {
      type: [Array, Object],
      required: true
    },
    icon: {
      type: String
    },
    iconOptions: {
      type: Object
    },
    popupContent: {
      type: String
    },
    hidden: {
      type: Boolean,
      default: false
    },
    bouncing: {
      type: Boolean,
      default: false
    },
    bouncingDuration: {
      type: Number,
      default: 0
    },
    bouncingOptions: {
      type: Object,
      default: () => {}
    },
    slide: {
      type: Boolean,
      default: false
    },
    slideDuration: {
      type: Number,
      default: 10000
    }
  },
  data () {
    return {
      map: null,
      marker: null
    }
  },
  watch: {
    hidden () {
      this.onHiddenChange()
    },
    coordinates () {
      if (this.slide) {
        this.marker.slideTo(this.coordinates, {
          duration: this.slideDuration
        })
      } else {
        this.marker.setLatLng(this.coordinates)
      }

      if (this.bouncing) {
        this.marker.bounce(this.bouncingDuration)
      }
    }
  },
  created () {
    this.map = getMapParent(this.$parent).map

    this.marker = L.marker(this.coordinates, {
      icon: this.getCustomIcon(this.icon, this.iconOptions)
    })
      .on('click', () => { this.$emit('click') })
      .on('mouseover', (e) => { e.target.openPopup() })
      .on('mouseout', (e) => { e.target.closePopup() })
      .on('add', (e) => {
        // Add tabindex manually to better support keyboard navigation
        // e.target._path.tabIndex = 0

        // Add keyboard submission support
        // e.target._path.addEventListener('keypress', (keyE) => {
        //   this.$emit('keypress', keyE)
        // })
      })

    if (this.bouncing) {
      this.marker
        .setBouncingOptions({
          bounceSpeed: 30,
          bounceHeight: 12,
          contractSpeed: 30,
          contractHeight: 5,
          ...this.bouncingOptions
        })
    }

    if (this.popupContent) {
      const popup = L.popup({
        offset: [0, -35]
      })
        .setContent(this.popupContent)

      this.marker.bindPopup(popup)
    }

    this.onHiddenChange()

    this.$emit('ready', this.map)
  },
  beforeDestroy () {
    this.map.removeLayer(this.marker)
  },
  methods: {
    onHiddenChange () {
      if (this.hidden) {
        this.map.removeLayer(this.marker)
      } else {
        this.map.addLayer(this.marker)

        if (this.bouncing) {
          this.marker.bounce(this.bouncingDuration)
        }
      }
    },
    getCustomIcon (name, optionsIn) {
      const options = {
        iconSize: [34, 48],
        iconAnchor: [17, 48],
        className: '',
        ...optionsIn
      }

      options.className += ' custom-icon'
      if (options.color) options.className += ` custom-icon-${options.color}`
      options.html = `
        <i class="fa ${name}"></i>
      `

      // if (options.color) {
      //   return L.ExtraMarkers.icon({
      //     icon: name,
      //     markerColor: options.color,
      //     prefix: 'fa'
      //   })
      // }

      return L.divIcon(options)
    }
  }
}
</script>

<style lang="scss">
@import '../../../node_modules/leaflet/dist/leaflet.css';
@import '../../../node_modules/leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';

#map {
  width: 100%;
  height: 100%;
  z-index: 0;

  position: absolute;
  top: 0;
  left: 0;

  transition: height 0.3s;

  .leaflet-routing-container {
    opacity: 0;
    height: 0;
    width: 0;
  }
}

.custom-icon {
  background-image: url('../../img/markers/Circle@3x.png');
  text-align: center;
  background-size: contain;

  &.custom-icon-red { background-image: url('../../img/markers/Circle-red@3x.png'); }
  &.custom-icon-yellow { background-image: url('../../img/markers/Circle-yellow@3x.png'); }

  i.fa {
    margin-top: 8px;
    font-size: 18px;
    color: white;
  }
}

</style>
